// extracted by css-extract-rspack-plugin
export default {"container":"container-_Yn4Nk","icon":"icon-VjBHO3","intermediateText":"intermediateText-uynHAJ","shimmer":"shimmer-U3U4ML"};